import axios from '../../axios'

// 新增线上院校
export const addOnLineSchool = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool',
        method: 'POST',
        data
    })
}

// 获取线上院校详情
export const getOnLineSchoolInfo = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool/info',
        method: 'GET',
        data
    })
}

// 修改线上院校信息
export const editOnLineSchoolInfo = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool',
        method: 'PUT',
        data
    })
}

// 删除线上院校信息
export const deleteOnLineSchoolInfo = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool',
        method: 'DELETE',
        data
    })
}

// 综合搜索线上院校信息列表
export const searchOnLineSchoolList = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool',
        method: 'GET',
        data
    })
}

// 线上院校信息导入
export const importOnLineSchool = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool/import',
        method: 'POST',
        data
    })
}

// 线上院校信息导出
export const exportOnLineSchool = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool/export',
        method: 'POST',
        data
    })
}

// 线上院校信息批量更新
export const updateOnLineSchool = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool/batch/update',
        method: 'POST',
        data
    })
}

// 线上院校信息批量删除
export const queryDelOnLineSchool = (data) => {
    return axios({
        url: '/api/data/wish/onlineschool/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/onlinschool.js